import React from "react";
import { User, Clock } from "lucide-react";

/* ── Format ISO datetime → "12 Jan 2026, 3:45 PM" ── */
export const formatDateTime = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const day = d.getDate();
  const month = d.toLocaleString("en-IN", { month: "short" });
  const year = d.getFullYear();
  let h = d.getHours();
  const min = String(d.getMinutes()).padStart(2, "0");
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${day} ${month} ${year}, ${h}:${min} ${ampm}`;
};

/**
 * Renders "Updated by: X  |  12 Jan 2026, 3:45 PM" badges.
 * Supports different color variants:
 * - success: Green theme (for completed/verified items)
 * - default: Gray theme (for regular updates)
 */
const DoneByBadge = ({ doneByName, doneAt, label = "Updated", variant = "default" }) => {
  if (!doneByName && !doneAt) return null;
  
  // Color variants
  const colors = {
    success: {
      bg: "bg-green-100",
      text: "text-green-800",
      icon: "text-green-600",
      border: "border-green-200"
    },
    default: {
      bg: "bg-gray-100",
      text: "text-gray-700",
      icon: "text-gray-500",
      border: "border-gray-200"
    }
  };
  
  const colorSet = colors[variant] || colors.default;
  
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {doneByName && (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-medium ${colorSet.bg} ${colorSet.text} border ${colorSet.border}`}>
          <User className={`h-3 w-3 shrink-0 ${colorSet.icon}`} />
          {label} by:&nbsp;<span className="font-semibold">{doneByName}</span>
        </span>
      )}
      {doneAt && (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-medium ${colorSet.bg} ${colorSet.text} border ${colorSet.border}`}>
          <Clock className={`h-3 w-3 shrink-0 ${colorSet.icon}`} />
          {formatDateTime(doneAt)}
        </span>
      )}
    </div>
  );
};

export default DoneByBadge;